import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    body: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  colors: {
    blue: {
      50: "#EBF8FF",
      100: "#BEE3F8",
      200: "#90CDF4",
      300: "#63B3ED",
      400: "#4299E1",
      500: "#3182CE",
      600: "#2B6CB0",
      700: "#2C5282",
      800: "#2A4365",
      900: "#1A365D",
    },
  },
  styles: {
    global: {
      "html, body": {
        fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        color: "gray.700",
        fontSize: "16px",
        lineHeight: "1.5",
      },
      "h1, h2, h3, h4": {
        fontWeight: "700",
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "600",
        borderRadius: "md",
      },
    },
    Input: {
      baseStyle: {
        field: {
          borderRadius: "md",
        },
      },
      defaultProps: {
        focusBorderColor: "blue.500",
      },
    },
    FormLabel: {
      baseStyle: {
        fontWeight: "700",
        color: "gray.900",
        fontSize: "md",
        mb: 1,
      },
    },
  },
});

export default theme;
